import Keycloak from "keycloak-js";

const keycloakConfig = {
  url: "https://auth.ttgteams.com/", // use http (not https for local dev)
  realm: "Invoicing_App",
  clientId: "client",
};

// Initialize Keycloak with the config object
const keycloak = new Keycloak(keycloakConfig);

export default keycloak;